import React from 'react';
import { Settings2 } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { useModelStore } from '@/stores/useModelStore';
import { GenerationModeToggle } from './BlogCreationCommandCenter/GenerationModeToggle';

/**
 * Combined popover for internal content generation settings.
 * Only shown to elevated platform roles.
 */
const ContentCreationOptions: React.FC = () => {
  const { generationMode, setGenerationMode } = useModelStore();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5 text-xs h-8">
          <Settings2 className="h-3.5 w-3.5" />
          <span className="hidden md:inline">Content Settings</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-4">
          <div>
            <h4 className="font-medium text-sm mb-1">Content Creation Options</h4>
            <p className="text-xs text-muted-foreground">
              These settings apply to all new content generation.
            </p>
          </div>

          <Separator />

          {/* Generation Mode */}
          <GenerationModeToggle
            mode={generationMode}
            onChange={setGenerationMode}
          />

        </div>
      </PopoverContent>
    </Popover>
  );
};

export default ContentCreationOptions;
